export default "__VITE_ASSET__CucYtRa5__"